export enum PropType {
  string = "string",
  number = "number",
  bool = "bool",
  event = "event"
}
